module.exports = __webpack_public_path__ + "img/gray-clock.4e89dabc.svg";